<template>
  <div class="wrapper" :class="targetClass">
    <slot name="icon">
      <FontAwesomeIcon v-if="icon" :icon="icon" class="icon" />
    </slot>

    <h2 class="title">{{ title }}</h2>

    <slot name="message">
      <p class="message">{{ message }}</p>
    </slot>
  </div>
</template>

<script>
export default {
  name: 'UtilEmpty',
  props: {
    icon: Object,
    title: String,
    message: String,
    targetClass: {
      type: String,
      default: 'bg-background text-gray-darker'
    }
  }
}
</script>

<style lang="scss" scoped>
.wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
}

// Use EM not REM as we want the icon title and message to scale with parent font size
// To make this component larger just provide a bigger font size to the component in parent
.icon {
  font-size: 3.5em;
}

.title {
  font-size: 1.4em;
  margin-top: 0.5em;
  margin-bottom: 0.5em;
}

.message {
  font-size: 1em;
}
</style>
